import React, { useEffect, useState } from 'react'
import ResourceMasterTable from './ResourceMasterTable'
import EditResource from './EditResource'
import AddResource from './AddResource'
import { toast } from 'react-toastify'
import api from '../../utils/api'

const ResourceMasterHome = () => {

    const [isEditClicked, setIsEditClicked] = useState(false)
    const [isAddClicked, setIsAddClicked] = useState(false)
    const [editResourceFields, setEditResourceFields] = useState({
        sResourceType: "",
        sResourceSubType: "",
        // rResourceCategory: "",
        sResourceID: "",
        sResourceName: "",
        // nExpectedTAT: 0
    })

    const [resourceCategory, setResourceCategory] = useState()
    const [resourceTypeOption, setResourceTypeOption] = useState()
    const [resourcesSubTypeOptions, setResourceSubTypeOptions] = useState();
    const [resourceMasterData, setResourceMasterData] = useState()
    const [knowledgeResourceList, setKnowledgeResourceList] = useState([]);
    const [personalizedResourceList, setPersonalizedResourceList] = useState([]);
    const [EventResourceList, setEventResourceList] = useState([]);
    const [personalizedServiceList, setPersonalizedServiceList] = useState([])

    const getResourceMasterTableData = () => {
        const { tempResourceType } = api.resourceTypeDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Resource Type", data)
                    const convertedResourceType = data.map(item => ({
                        value: item.stype,
                        label: item.stype
                    }))
                    setResourceTypeOption(convertedResourceType)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        const { tempResourceSubtype } = api.resourceSubtypeDropdownData()
            .then(({ data }) => {
                if (data) {
                    console.log("Resource Subtype", data)
                    const convertedResourceSubtype = data.map(item => ({
                        value: item.ssubtype,
                        label: item.ssubtype
                    }))
                    setResourceSubTypeOptions(convertedResourceSubtype)
                }
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })

        // const { tempResourceCategory } = api.resourceCategoryDropdownData()
        //     .then(({ data }) => {
        //         if (data) {
        //             console.log("Resource Category", data)
        //             const convertedresourceCategoryData = data.map(item => ({
        //                 value: item.category,
        //                 label: item.category
        //             }))
        //             setResourceCategory(convertedresourceCategoryData)
        //         }
        //     }).catch((error) => {
        //         if (error.response.data.detail !== "Authentication credentials were not provided.") {
        //             toast(String(error.response.data.detail), {
        //                 autoClose: 5000,
        //                 type: toast.TYPE.ERROR,
        //             });
        //         } else if (error.response.data.message) {
        //             toast(String(error.response.data.message), {
        //                 autoClose: 5000,
        //                 type: toast.TYPE.ERROR,
        //             });
        //         } else {
        //             toast("Something went Wrong!", {
        //                 autoClose: 5000,
        //                 type: toast.TYPE.ERROR,
        //             });
        //         }
        //     })

        const { tempResourceCategory } = api.getDisableFalseServiceRequestsNames({ bDisableService: false, all_resources: true })
            .then((d) => {
                setKnowledgeResourceList(d.data.knowledge_resource)
                setPersonalizedResourceList(d.data.personalized_resource);
                setPersonalizedServiceList(d.data.service_types)
                if (d.data.events) {
                    setEventResourceList(d.data.events);
                }
                else {
                    setEventResourceList([]);
                }
            })

        const { tempGetResourceMaster } = api.getResourceMasterData()
            .then(({ data }) => {
                console.log("ResourceMaster", data)

                function sortByResourceID(data) {
                    return data.sort((a, b) => {
                        const idA = a.sResourceID;
                        const idB = b.sResourceID;

                        // Convert both to string
                        const strA = idA?.toString().trim().toLowerCase() || '';
                        const strB = idB?.toString().trim().toLowerCase() || '';

                        // Try to extract numeric parts if possible
                        const numA = parseInt(strA.replace(/\D/g, '')) || 0;
                        const numB = parseInt(strB.replace(/\D/g, '')) || 0;

                        // First compare alphabetic prefix
                        const prefixA = strA.replace(/[0-9]/g, '');
                        const prefixB = strB.replace(/[0-9]/g, '');

                        if (prefixA < prefixB) return -1;
                        if (prefixA > prefixB) return 1;

                        // If prefix same, compare numeric part
                        return numA - numB;
                    });
                }

                let sortedData = sortByResourceID(data)

                setResourceMasterData(sortedData)
            }).catch((error) => {
                if (error.response.data.detail !== "Authentication credentials were not provided.") {
                    toast(String(error.response.data.detail), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else if (error.response.data.message) {
                    toast(String(error.response.data.message), {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                } else {
                    toast("Something went Wrong!", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
            })
    }

    useEffect(() => {
        console.log("useeffect is called")
        getResourceMasterTableData()
    }, [])


    const [isFinancialDataService, setIsFinancialDataService] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [isServiceProvider, setIsServiceProvider] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [isUnusedService, setIsUnusedService] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [serviceProviderOnly, setServiceProviderOnly] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [disableService, setDisableService] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [engagementResource, setEngagementResource] = useState([
        {
            value: true,
            label: "Yes",
        },
        {
            value: false,
            label: "No",
        }
    ])

    const [resourceSubtype, setResourceSubType] = useState()

    const [selectedResourceType, setSelectedResourceType] = useState("")
    const [selectedResourceSubType, setSelectedResourceSubType] = useState("")
    const [selectedIsFinancialDataService, setSelectedIsFinancialDataService] = useState({
        value: false,
        label: "No"
    })
    const [selectedIsServiceProvider, setSelectedIsServiceProvider] = useState({
        value: false,
        label: "No"
    })
    const [selectedIsUnusedService, setSelectedIsUnusedService] = useState({
        value: false,
        label: "No"
    })
    const [selectedServiceProviderOnly, setSelectedServiceProviderOnly] = useState({
        value: false,
        label: "No"
    })
    const [selectedDisableService, setSelectedDisableService] = useState({
        value: false,
        label: "No"
    })
    const [selectedEngagementResource, setSelectedEngagementResource] = useState({
        value: false,
        label: "No"
    })
    const [selectedResourceCategory, setSelectedResourceCategory] = useState(undefined)
    const [resourceID, setResourceId] = useState("")

    const onResourceTypeChange = (option) => {
        setSelectedResourceType(option)
        setSelectedResourceSubType("")
    }

    const onResourceSubTypeChange = (option) => {
        setSelectedResourceSubType(option)
        setSelectedResourceCategory("")
    }

    const onIsFinancialDataServiceChange = (option) => {
        setSelectedIsFinancialDataService(option)
    }

    const onIsServiceProviderChange = (option) => {
        setSelectedIsServiceProvider(option)
    }

    const onIsUnusedServiceChange = (option) => {
        setSelectedIsUnusedService(option)
    }

    const onServiceProviderOnlyChange = (option) => {
        setSelectedServiceProviderOnly(option)
    }

    const onDisableServiceChange = (option) => {
        setSelectedDisableService(option)
    }

    const onEngagementResourceChange = (option) => {
        setSelectedEngagementResource(option)
    }

    const onResourceCategoryChange = (option) => {
        setSelectedResourceCategory(option)
    }

    const addResource = () => {
        setIsAddClicked(true)
    }

    const editResource = (e) => {
        setEditResourceFields({
            sResourceType: e.sResourceType,
            sResourceSubType: e.sResourceSubType,
            sResourceID: e.sResourceID,
            sResourceName: e.sResourceName,
            nExpectedTAT: e.nExpectedTAT
        })
        setResourceId(e.id)
        setIsEditClicked(true)
        console.log("Edit Resource", editResourceFields)
        const ResourceTypeData = {
            value: e.sResourceType,
            label: e.sResourceType
        }
        const ResourceSubTypeData = {
            value: e.sResourceSubType,
            label: e.sResourceSubType
        }
        const FinancialDataServiceOption = {
            value: e.blsFinancialDataService,
            label: e.blsFinancialDataService === false ? "No" : "Yes"
        }
        const ServiceProviderOption = {
            value: e.blsServiceProvider,
            label: e.blsServiceProvider === false ? "No" : "Yes"
        }
        const UnusedServiceOption = {
            value: e.bUnusedService,
            label: e.bUnusedService === false ? "No" : "Yes"
        }
        const ServiceProviderOnlyOption = {
            value: e.bServiceProviderOnly,
            label: e.bServiceProviderOnly === false ? "No" : "Yes"
        }
        const disableServiceOption = {
            value: e.bDisableService,
            label: e.bDisableService === false ? "No" : "Yes"
        }
        const EngagementResourceOption = {
            value: e.bEngagementResource,
            label: e.bEngagementResource === false ? "No" : "Yes"
        }
        const ResourceCategoryOptions = {
            value: e.rResourceCategory,
            label: e.rResourceCategory
        }
        setSelectedResourceType(ResourceTypeData)
        setSelectedResourceSubType(ResourceSubTypeData)
        setSelectedIsFinancialDataService(FinancialDataServiceOption)
        setSelectedIsServiceProvider(ServiceProviderOption)
        setSelectedIsUnusedService(UnusedServiceOption)
        setSelectedServiceProviderOnly(ServiceProviderOnlyOption)
        setSelectedDisableService(disableServiceOption)
        setSelectedEngagementResource(EngagementResourceOption)
        setSelectedResourceCategory(ResourceCategoryOptions)
    }

    useEffect(() => {
        if (selectedResourceType.value === "Personalized Service") {
            const options = resourcesSubTypeOptions.filter(
                (option) => option.value === "Service" || option.value === "Program"
            );
            setResourceSubType(options);
        } else if (selectedResourceType.value === "Knowledge Resource") {
            const options = resourcesSubTypeOptions.filter(
                (option) => option.value === "Checklist" || option.value === "Feedback"
                    || option.value === "Magazine" || option.value === "EJM Map" ||
                    option.value === "deAsra Marketing Event" || option.value === "Partner Marketing Event" ||
                    option.value === "Website" || option.value === "Inspire Program" ||
                    option.value === "YUSubscription" || option.value === "YUSubscriptionEN" ||
                    option.value === "YUSubscriptionHI"
            );
            setResourceSubType(options);
        } else if (selectedResourceType.value === "Personalized Resource") {
            const options = resourcesSubTypeOptions.filter(
                (option) =>
                    option.value === "Tool" || option.value === "Template"
            );
            setResourceSubType(options);
        } else {
            setResourceSubType([]);
        }
    }, [selectedResourceType]);

    useEffect(() => {

        if (selectedResourceSubType.value === "Service") {
            const filteredCategories = personalizedServiceList
                .filter(ele => ele.sServiceCategory && ele.sServiceCategory.trim() !== "") // Filter out null and empty values
                .map(ele => ele.sServiceCategory);

            const uniqueCategories = [...new Set(filteredCategories)];

            const options = uniqueCategories.map(category => ({
                value: category,
                label: category
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Program") {
            const filteredResources = personalizedResourceList.filter(
                ele => ele.sResourceSubType === "Program"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Tool") {
            const filteredResources = personalizedResourceList.filter(
                ele => ele.sResourceSubType === "Tool"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Template") {
            const filteredResources = personalizedResourceList.filter(
                ele => ele.sResourceSubType === "Template"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Checklist") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Checklist"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Feedback") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Feedback"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Magazine") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Magazine"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "EJM Map") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "EJM Map"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "deAsra Marketing Event") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "deAsra Marketing Event"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Partner Marketing Event") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Partner Marketing Event"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Website") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Website"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "YUSubscription") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "YUSubscription"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Udyojak Katta") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Udyojak Katta"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        }else if (selectedResourceSubType.value === "YUSubscriptionEN") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "YUSubscriptionEN"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "YUSubscriptionHI") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "YUSubscriptionHI"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        } else if (selectedResourceSubType.value === "Inspire Program") {
            const filteredResources = knowledgeResourceList.filter(
                ele => ele.sResourceSubType === "Inspire Program"
            );

            const options = filteredResources.map(resource => ({
                value: resource.sResourceName,
                label: resource.sResourceName
            }));
            setResourceCategory(options)
        }
        else {
            setResourceCategory([])
        }

    }, [selectedResourceSubType])

    const BackPage = () => {
        setIsEditClicked(false)
        setEditResourceFields({
            sResourceType: "",
            sResourceSubType: "",
            sResourceID: "",
            sResourceName: "",
            nExpectedTAT: 0
        })
        setSelectedResourceSubType("")
        setSelectedResourceType("")
        setSelectedIsFinancialDataService({
            value: false,
            label: "No"
        })
        setSelectedIsServiceProvider({
            value: false,
            label: "No"
        })
        setSelectedIsUnusedService({
            value: false,
            label: "No"
        })
        setSelectedServiceProviderOnly({
            value: false,
            label: "No"
        })
        setSelectedDisableService({
            value: false,
            label: "No"
        })
        setSelectedEngagementResource({
            value: false,
            label: "No"
        })
        setSelectedResourceCategory(undefined)
    }

    const BackPage1 = () => {
        setIsAddClicked(false)
        setEditResourceFields({
            sResourceType: "",
            sResourceSubType: "",
            sResourceID: "",
            sResourceName: "",
            nExpectedTAT: 0
        })
        setSelectedResourceSubType("")
        setSelectedResourceType("")
        setSelectedIsFinancialDataService({
            value: false,
            label: "No"
        })
        setSelectedIsServiceProvider({
            value: false,
            label: "No"
        })
        setSelectedIsUnusedService({
            value: false,
            label: "No"
        })
        setSelectedServiceProviderOnly({
            value: false,
            label: "No"
        })
        setSelectedDisableService({
            value: false,
            label: "No"
        })
        setSelectedEngagementResource({
            value: false,
            label: "No"
        })
        setSelectedResourceCategory(undefined)
    }

    const handleChange = (name, value) => {
        const updated = { ...editResourceFields, [name]: value };
        setEditResourceFields(updated);

        const {
            sResourceID,
            sResourceName,
            nExpectedTAT
        } = updated;

        if (name === 'sResourceID') {
            const isRIdUnique = resourceMasterData.every(item => item.sResourceID !== value);

            if (!isRIdUnique) {
                toast("Resource Id is not unique. Please choose a different Resource Id.", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }
    };

    const onSaveClick = () => {
        console.log(editResourceFields, ">>>>>editResourceFields on add save click");

        const isRIdUnique = resourceMasterData.every(item => item.sResourceID !== editResourceFields.sResourceID);
        try {
            console.log("Hey", selectedResourceCategory)
            if (selectedResourceType === "" || null) {
                toast("Resource Type Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedResourceSubType === "" || null) {
                toast("Resource SubType Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            // else if (!selectedResourceCategory) {
            //     toast("Resource Category Required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // }
            else if (editResourceFields.sResourceID === "" || null) {
                toast("Resource ID Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            else if (!isRIdUnique) {
                toast(
                    "Resource ID is not unique",
                    {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    }
                );
            }
            else if (editResourceFields.sResourceName === "" || null) {
                toast("Resource Display Name Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            // else if (selectedIsFinancialDataService === undefined || null) {
            //     toast("Please Select Is Financial Data Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedIsServiceProvider === undefined || null) {
            //     toast("Please Select Is Service Provider", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedIsUnusedService === undefined || null) {
            //     toast("Please Select Is Unused Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedServiceProviderOnly === undefined || null) {
            //     toast("Please Select Service Provider Only", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedDisableService === undefined || null) {
            //     toast("Please Select Disable Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedEngagementResource === undefined || null) {
            //     toast("Please Select Engagement Resource", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } 
            // else if (editResourceFields.nExpectedTAT === "" || null) {
            //     toast("Please Select Expected TAT", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } 
            else {
                let payload = {
                    sResourceType: selectedResourceType.value,
                    sResourceSubType: selectedResourceSubType.value,
                    // rResourceCategory: selectedResourceCategory.value,
                    sResourceID: editResourceFields.sResourceID,
                    sResourceName: editResourceFields.sResourceName,
                    // blsFinancialDataService: selectedIsFinancialDataService.value,
                    // blsServiceProvider: selectedIsServiceProvider.value,
                    // bUnusedService: selectedIsUnusedService.value,
                    // bServiceProviderOnly: selectedServiceProviderOnly.value,
                    // bDisableService: selectedDisableService.value,
                    // bEngagementResource: selectedEngagementResource.value,
                    // nExpectedTAT: editResourceFields.nExpectedTAT,
                    // rResourceCategory_link: selectedResourceCategory.value
                }
                api.addResourceMasterData(payload)
                    .then(({ data }) => {
                        console.log("add resource", data)
                        if (data.Message === "Created Successfully.") {
                            toast("Added Resource", {
                                autoClose: 5000,
                                type: toast.TYPE.SUCCESS,
                            })
                            setIsEditClicked(false)
                            setIsAddClicked(false)
                            getResourceMasterTableData()
                            setSelectedResourceSubType("")
                            setSelectedResourceType("")
                            setSelectedIsFinancialDataService({
                                value: false,
                                label: "No"
                            })
                            setSelectedIsServiceProvider({
                                value: false,
                                label: "No"
                            })
                            setSelectedIsUnusedService({
                                value: false,
                                label: "No"
                            })
                            setSelectedServiceProviderOnly({
                                value: false,
                                label: "No"
                            })
                            setSelectedDisableService({
                                value: false,
                                label: "No"
                            })
                            setSelectedEngagementResource({
                                value: false,
                                label: "No"
                            })
                            setSelectedResourceCategory(undefined)
                            setEditResourceFields({
                                sResourceType: "",
                                sResourceSubType: "",
                                sResourceID: "",
                                sResourceName: "",
                                nExpectedTAT: 0
                            })
                        } else {
                            console.log("rrrrr")
                            toast(data.Message, {
                                autoClose: 5000,
                                type: toast.TYPE.ERROR,
                            })
                        }
                    })

            }
        } catch (error) {
            console.log("WJHA", error)
            toast(error.Message, {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }

    }

    const onSaveClick1 = () => {
        const isRIdUnique = resourceMasterData.every(item => item.sResourceID !== editResourceFields.sResourceID);
        try {
            console.log("ResourceId", selectedResourceCategory)
            // if (selectedResourceCategory === "" || null) {
            //     toast("Resource Category Required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (editResourceFields.sResourceID === "" || null) {
            //     toast("Resource ID Required", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } 
            // else if (!isRIdUnique) {
            //     toast(
            //         "Resource ID is not unique",
            //         {
            //             autoClose: 5000,
            //             type: toast.TYPE.ERROR,
            //         }
            //     );
            // } 
            if (editResourceFields.sResourceName === "" || null) {
                toast("Resource Display Name Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedResourceType === "" || null) {
                toast("Resource Type Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else if (selectedResourceSubType === "" || null) {
                toast("Resource SubType Required", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            }
            // else if (selectedIsFinancialDataService === "" || null) {
            //     toast("Please Select Is Financial Data Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedIsServiceProvider === "" || null) {
            //     toast("Please Select Is Service Provider", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedIsUnusedService === "" || null) {
            //     toast("Please Select Is Unused Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedServiceProviderOnly === "" || null) {
            //     toast("Please Select Service Provider Only", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedDisableService === "" || null) {
            //     toast("Please Select Disable Service", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } else if (selectedEngagementResource === "" || null) {
            //     toast("Please Select Engagement Resource", {
            //         autoClose: 5000,
            //         type: toast.TYPE.ERROR,
            //     })
            // } 
            else if (editResourceFields.nExpectedTAT === "" || null) {
                toast("Please Select Expected TAT", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                })
            } else {
                let payload = {
                    sResourceType: selectedResourceType.value,
                    sResourceSubType: selectedResourceSubType.value,
                    // rResourceCategory: selectedResourceCategory.value,
                    sResourceID: editResourceFields.sResourceID,
                    sResourceName: editResourceFields.sResourceName,
                    // blsFinancialDataService: selectedIsFinancialDataService.value,
                    // blsServiceProvider: selectedIsServiceProvider.value,
                    // bUnusedService: selectedIsUnusedService.value,
                    // bServiceProviderOnly: selectedServiceProviderOnly.value,
                    // bDisableService: selectedDisableService.value,
                    // bEngagementResource: selectedEngagementResource.value,
                    // nExpectedTAT: editResourceFields.nExpectedTAT,
                    // rResourceCategory_link: selectedResourceCategory.value
                }

                api.updateResourceMasterData(payload, resourceID)
                    .then(({ data }) => {
                        console.log("Updated", data)
                        toast("Resource Updated", {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        })
                        console.log("Yoo", payload)
                        setIsEditClicked(false)
                        setIsAddClicked(false)
                        getResourceMasterTableData()
                        setSelectedResourceSubType("")
                        setSelectedResourceType("")
                        setSelectedIsFinancialDataService({
                            value: false,
                            label: "No"
                        })
                        setSelectedIsServiceProvider({
                            value: false,
                            label: "No"
                        })
                        setSelectedIsUnusedService({
                            value: false,
                            label: "No"
                        })
                        setSelectedServiceProviderOnly({
                            value: false,
                            label: "No"
                        })
                        setSelectedDisableService({
                            value: false,
                            label: "No"
                        })
                        setSelectedEngagementResource({
                            value: false,
                            label: "No"
                        })
                        setSelectedResourceCategory(undefined)
                        setEditResourceFields({
                            sResourceType: "",
                            sResourceSubType: "",
                            sResourceID: "",
                            sResourceName: "",
                            nExpectedTAT: 0
                        })
                    })
                // .catch(() => {
                //     toast("Something Went Wrong", {
                //         autoClose: 5000,
                //         type: toast.TYPE.ERROR,
                //     })
                // })
            }
        } catch (error) {
            toast("Something Went Wrong", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }

    }


    return (
        <div>

            <div className="row mt-3">
                <div className="col-12">
                    <label>
                        <b>Resource Master View</b>
                    </label>
                </div>
            </div>
            {
                !isEditClicked && !isAddClicked ?
                    <div className="row  mb-3">
                        <div className="col-12">
                            <ResourceMasterTable
                                handleChange={handleChange}
                                editResource={editResource}
                                onAddClick={addResource}
                                resourceMasterData={resourceMasterData}
                                getResourceMasterTableData={getResourceMasterTableData}
                            />
                        </div>
                    </div>
                    :
                    isEditClicked ?
                        <div className="row">
                            <div className="col-12">
                                <EditResource
                                    handleChange={handleChange}
                                    editResourceFields={editResourceFields}
                                    BackPage={BackPage}
                                    onResourceTypeChange={onResourceTypeChange}
                                    onResourceSubTypeChange={onResourceSubTypeChange}
                                    resourceTypeOption={resourceTypeOption}
                                    resourceSubtype={resourceSubtype}
                                    selectedResourceType={selectedResourceType}
                                    selectedResourceSubType={selectedResourceSubType}
                                    onSaveClick={onSaveClick1}
                                    onIsFinancialDataServiceChange={onIsFinancialDataServiceChange}
                                    isFinancialDataService={isFinancialDataService}
                                    selectedIsFinancialDataService={selectedIsFinancialDataService}
                                    onIsServiceProviderChange={onIsServiceProviderChange}
                                    selectedIsServiceProvider={selectedIsServiceProvider}
                                    isServiceProvider={isServiceProvider}
                                    onIsUnusedServiceChange={onIsUnusedServiceChange}
                                    isUnusedService={isUnusedService}
                                    selectedIsUnusedService={selectedIsUnusedService}
                                    onServiceProviderOnlyChange={onServiceProviderOnlyChange}
                                    serviceProviderOnly={serviceProviderOnly}
                                    selectedServiceProviderOnly={selectedServiceProviderOnly}
                                    onDisableServiceChange={onDisableServiceChange}
                                    disableService={disableService}
                                    selectedDisableService={selectedDisableService}
                                    onEngagementResourceChange={onEngagementResourceChange}
                                    engagementResource={engagementResource}
                                    selectedEngagementResource={selectedEngagementResource}
                                    onResourceCategoryChange={onResourceCategoryChange}
                                    resourceCategory={resourceCategory}
                                    selectedResourceCategory={selectedResourceCategory}
                                />
                            </div>
                        </div>
                        :
                        isAddClicked ?
                            <div className="row">
                                <div className="col-12">
                                    <AddResource
                                        handleChange={handleChange}
                                        editResourceFields={editResourceFields}
                                        BackPage={BackPage1}
                                        onResourceTypeChange={onResourceTypeChange}
                                        onResourceSubTypeChange={onResourceSubTypeChange}
                                        resourceTypeOption={resourceTypeOption}
                                        resourceSubtype={resourceSubtype}
                                        selectedResourceType={selectedResourceType}
                                        selectedResourceSubType={selectedResourceSubType}
                                        onSaveClick={onSaveClick}
                                        onIsFinancialDataServiceChange={onIsFinancialDataServiceChange}
                                        isFinancialDataService={isFinancialDataService}
                                        selectedIsFinancialDataService={selectedIsFinancialDataService}
                                        onIsServiceProviderChange={onIsServiceProviderChange}
                                        selectedIsServiceProvider={selectedIsServiceProvider}
                                        isServiceProvider={isServiceProvider}
                                        onIsUnusedServiceChange={onIsUnusedServiceChange}
                                        isUnusedService={isUnusedService}
                                        selectedIsUnusedService={selectedIsUnusedService}
                                        onServiceProviderOnlyChange={onServiceProviderOnlyChange}
                                        serviceProviderOnly={serviceProviderOnly}
                                        selectedServiceProviderOnly={selectedServiceProviderOnly}
                                        onDisableServiceChange={onDisableServiceChange}
                                        disableService={disableService}
                                        selectedDisableService={selectedDisableService}
                                        onEngagementResourceChange={onEngagementResourceChange}
                                        engagementResource={engagementResource}
                                        selectedEngagementResource={selectedEngagementResource}
                                        onResourceCategoryChange={onResourceCategoryChange}
                                        resourceCategory={resourceCategory}
                                        selectedResourceCategory={selectedResourceCategory}
                                    />
                                </div>
                            </div>
                            :
                            ""


            }
        </div>
    )
}

export default ResourceMasterHome
